import { applyUrlFeatureOverrides } from '@/context/FeatureToggleContext/urlFeatureOverrides';
import setEnvironmentFavicon from '@/utils/setEnvironmentFavicon';
import { setupHighcharts } from '@/utils/highcharts/setupHighcharts';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { loadAdobeDTMScript } from './utils';
import { loadWalkMeScript } from './utils/loadWalkMeScript';
import { Logger } from './utils/Logger';

setupHighcharts();
loadWalkMeScript();

loadAdobeDTMScript().then(() => {
  setEnvironmentFavicon();
  applyUrlFeatureOverrides(window.location.search);
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <StrictMode>
      <BrowserRouter future={{ v7_startTransition: false, v7_relativeSplatPath: false }} basename="/">
        <App />
      </BrowserRouter>
    </StrictMode>,
  );

  Logger.log(
    `'%c 
      ######    ######     ######   ##     ##  ######## 
      ##   ##  ##    ##   ##    ##  ##     ##  ##       
      ##   ## ##      ## ##         ##     ##  ##       
      ######  ##      ## ##         #########  #######  
      ##   ## ##      ## ##         ##     ##  ##     
      ##   ##  ##    ##   ##    ##  ##     ##  ## 
      ##   ##   ######     ######   ##     ##  ########
    `,
    'color: blue; font-weight: bold; font-family: monospace;',
  );
  Logger.log('%cEverything looks good!', 'color: green; font-size: 16px; font-weight: bold;');
});

if (import.meta.hot) {
  import.meta.hot.accept();
}
